import { MultiDropdownValue } from '@make-software/cspr-design/dist/lib/components/dropdown/dropdown';
import categories from 'app/components/common/categories/category-service';

export const CategoriesDropdownList: MultiDropdownValue[] = categories.map((category) => ({
  label: category.name,
  value: category.name,
  chipLabel: category.name,
  chipName: category.name
}));
